import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { memo, useState } from "react";
import SidebarBoxContainer from "../SidebarBoxContainer";
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import uuidToHash from "../utils/uuid-to-hash";
var theme = createTheme();
var GroupItemDiv = styled("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    flexDirection: "column",
    marginBottom: "1rem",
    "& > label": {
      fontSize: "1rem",
      marginBottom: ".5rem",
      textTransform: "capitalize"
    }
  };
});

var GroupItem = function GroupItem(_ref2) {
  var group = _ref2.group;
  return React.createElement(GroupItemDiv, null, uuidToHash(group.id));
};

var GroupList = function GroupList(_ref3) {
  var groups = _ref3.groups;
  return React.createElement("div", null, React.createElement("h2", null, "Groups"), groups.map(function (g, idx) {
    return React.createElement(GroupItem, {
      key: "".concat(g, "-").concat(idx),
      group: g
    });
  }));
};

var AddGroupFormDiv = styled("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    flexDirection: "row"
  };
});

var AddGroupFrom = function AddGroupFrom(_ref5) {
  var onAddGroup = _ref5.onAddGroup;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(e) {
    setValue(e.target.value);
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onAddGroup(value);
    setValue('');
  };

  return React.createElement(AddGroupFormDiv, null, React.createElement("form", {
    onSubmit: handleSubmit,
    style: {
      display: "flex",
      paddingRight: "6px"
    }
  }, React.createElement("input", {
    type: "text",
    value: value,
    name: "new-group",
    placeholder: "New group name",
    onChange: handleChange,
    style: {
      marginRight: "1rem"
    }
  }), React.createElement("input", {
    type: "submit",
    value: "Create group"
  })));
};

var DivContainer = styled("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: 12,
    "& h1": {
      fontSize: 18
    },
    "& h2": {
      fontSize: 14
    },
    "& h3": {
      fontSize: 12
    },
    "& h4": {
      fontSize: 12
    },
    "& h5": {
      fontSize: 12
    },
    "& h6": {
      fontSize: 12
    },
    "& p": {
      fontSize: 12
    },
    "& a": {},
    "& img": {
      width: "100%"
    }
  };
});
export var GroupsEditorSidebarBox = function GroupsEditorSidebarBox(_ref7) {
  var groups = _ref7.groups,
      onAddGroup = _ref7.onAddGroup;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SidebarBoxContainer, {
    title: "Groups",
    icon: React.createElement(FilterNoneIcon, {
      style: {
        color: grey[700]
      }
    }),
    expandedByDefault: true
  }, React.createElement(DivContainer, null, React.createElement("h2", null, "Add new group"), React.createElement(AddGroupFrom, {
    onAddGroup: onAddGroup
  }), React.createElement(GroupList, {
    groups: groups
  }))));
};
export default memo(GroupsEditorSidebarBox);